import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  flexpaysale: null,
  flexpaysales: [],
  success: false,
  error: null,
  message: null,
};

export const flexpaysaleReducer = createReducer(initialState, (builder) => {
  builder
    // Flexpaysale Creation
    .addCase('flexpaysaleCreateRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('flexpaysaleCreateSuccess', (state, action) => {
      state.isLoading = false;
      state.flexpaysale = action.payload;
      state.success = true;
      state.message = "Flexpaysale created successfully!";
    })
    .addCase('flexpaysaleCreateFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Get All Flexpaysales
    .addCase('getAllFlexpaysalesRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllFlexpaysalesSuccess', (state, action) => {
      state.isLoading = false;
      state.flexpaysales = action.payload;
    })
    .addCase('getAllFlexpaysalesFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Get Flexpaysales by Store
    .addCase('getFlexpaysalesByStoreRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getFlexpaysalesByStoreSuccess', (state, action) => {
      state.isLoading = false;
      state.flexpaysales = action.payload;
    })
    .addCase('getFlexpaysalesByStoreFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Get Single Flexpaysale
    .addCase('getSingleFlexpaysaleRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getSingleFlexpaysaleSuccess', (state, action) => {
      state.isLoading = false;
      state.flexpaysale = action.payload;
    })
    .addCase('getSingleFlexpaysaleFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Update Flexpaysale
    .addCase('updateFlexpaysaleRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateFlexpaysaleSuccess', (state, action) => {
      state.isLoading = false;
      state.flexpaysale = action.payload;
      state.success = true;
      state.message = "Flexpaysale updated successfully!";
    })
    .addCase('updateFlexpaysaleFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Update Flexpaysale Payment
    .addCase('updateFlexpaysalePaymentRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateFlexpaysalePaymentSuccess', (state, action) => {
      state.isLoading = false;
      state.flexpaysale = action.payload;
      state.success = true;
      state.message = "Payment updated successfully!";
    })
    .addCase('updateFlexpaysalePaymentFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Add Payment to Flexpaysale
    .addCase('addPaymentToFlexpaysaleRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('addPaymentToFlexpaysaleSuccess', (state, action) => {
      state.isLoading = false;
      state.flexpaysale = action.payload;
      state.success = true;
      state.message = "Payment added successfully!";
    })
    .addCase('addPaymentToFlexpaysaleFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Delete Flexpaysale
    .addCase('deleteFlexpaysaleRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteFlexpaysaleSuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase('deleteFlexpaysaleFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })
    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});